



























import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { Mobile } from "@/mixins/mobile";

@Component
export default class AccordionSectionCheckout extends Mixins(Mobile) {
  @Prop({ default: false }) readonly value!: boolean;
  protected isOpen = false;
  protected bodyHeight = "0px";

  $refs!: { body: HTMLDivElement };

  get bodyStyle(): Record<string, string> {
    return {
      maxHeight: this.isOpen ? this.bodyHeight : "0px"
    };
  }

  created() {
    this.isOpen = this.value;
  }

  mounted() {
    if (this.isOpen) {
      this.measureHeight();
    }
  }

  @Watch("value")
  onValueChange(val: boolean) {
    this.isOpen = val;
    if (val) {
      this.$nextTick(() => this.measureHeight());
    }
  }

  toggle() {
    if (!this.isOpen) {
      // Measure before opening so transition has a target
      this.$nextTick(() => this.measureHeight());
    }
    this.isOpen = !this.isOpen;
    this.$emit("input", this.isOpen);
  }

  protected measureHeight(): void {
    const el = this.$refs.body;
    if (el) {
      this.bodyHeight = el.scrollHeight + "px";
    }
  }

  updated() {
    if (this.isOpen) {
      this.$nextTick(() => this.measureHeight());
    }
  }
}
